import { render, staticRenderFns } from "./StudentCourseForm.vue?vue&type=template&id=5f3f0ee2"
import script from "./StudentCourseForm.vue?vue&type=script&lang=js"
export * from "./StudentCourseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3f0ee2')) {
      api.createRecord('5f3f0ee2', component.options)
    } else {
      api.reload('5f3f0ee2', component.options)
    }
    module.hot.accept("./StudentCourseForm.vue?vue&type=template&id=5f3f0ee2", function () {
      api.rerender('5f3f0ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/manytomany/StudentCourseForm.vue"
export default component.exports